import React from 'react'
import styled from 'styled-components'

import SiteIcons from '../assets/SiteIcons'
import PreviewButton from './PreviewButton'

import {Collapse} from 'react-collapse'

class MobileListing extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      toggled: false,
      toggleClass: ''
    }
    this.toggleMe = this.toggleMe.bind(this)
  }

  toggleMe() {
    if ( this.state.toggled === true ) {
      this.setState({
        toggled: false,
        toggleClass: ''
      })
    } else {
      this.setState({
        toggled: true,
        toggleClass: 'active'
      })
    }
  }

  render () {

    const AddToReport = this.props.courseLanguages.split('|')
    const Languages = ['English']

    if (AddToReport.includes('Spanish')) {
      Languages.push('Spanish')
    }

    if (AddToReport.includes('French')) {
      Languages.push('French')
    }

    const MobileShown = styled.div`
      &:hover {
        h1 {
          color: ${this.props.themeStyles.mainColor};
        }

        .openClose {
          background-color: rgb(220,220,220);
          .vert, .hor {
            background-color: ${this.props.themeStyles.mainColor};
          }
        }
      }
    `
    return (
      <div className="mobileListing">
        <MobileShown className="mobileShown" onClick={this.toggleMe}>
          <h1>{this.props.courseName}<span className={"openClose " + this.state.toggleClass}><span className="vert"></span><span className="hor"></span></span></h1>
          <div className="details">
            <span className="duration">
              <SiteIcons icon='time' />
              <span>{this.props.courseHours}:{this.props.courseMins}</span>
            </span>
            <span className="languages"><SiteIcons icon="languages" />

            {Languages.map((lan, idx) => {

                let langComma = ''
                let langLength = Languages.length - 1;

                if ( idx !== langLength) {
                  langComma = ','
                }

                return <span key={idx}>{lan}{langComma}</span>
              })}
            </span>
          </div>
        </MobileShown>
        <Collapse isOpened={this.state.toggled}>
          <div className="collapsedContent">
            <p>{this.props.desc}</p>
            <PreviewButton
              localURL={this.props.localURL}
              loggedInInfo={this.props.loggedInInfo}
              courseName={this.props.courseName}
              courseURL={this.props.courseURL}
              languages={Languages}
              supported={this.props.supported}
              themeStyles={this.props.themeStyles} />
          </div>
        </Collapse>

      </div>
    )

  }

}


export default MobileListing
